import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const countriesApi = createAsyncThunk("countries", async () => {
  const response = await axiosInstance.get("/countries");
  return response.data;
});

const countriesSlice = createSlice({
  name: "countries",
  initialState: {
    countries: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(countriesApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(countriesApi.fulfilled, (state, action) => {
        state.countries = action.payload;
        state.loading = false;
      })
      .addCase(countriesApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default countriesSlice.reducer;
